export default __webpack_public_path__ + "static/media/cf3.4610d857.jpg";